export default __webpack_public_path__ + "static/logo-footer-de9a0fa4ef4b20382288b354a936b46e.svg";